<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <el-date-picker
        v-model="times"
        type="daterange"
        clearable
        @change="onTimeChange()"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"/>
      <el-input
        placeholder="物流单号"
        v-model="body.keyword"
        clearable
        @change="handleCurrentChange()"
        class="input-with-select dk_input">
        <el-button
          slot="append"
          @click="handleCurrentChange()"
          icon="el-icon-search"/>
      </el-input>
      <div>
        <el-button
          type="primary"
          plain
          @click="event().toAddClick({})">新增物流单</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      border
      :data="tableData">
      <el-table-column
        prop="logistics_num"
        label="物流单号"/>
      <el-table-column
        prop="delivery_time"
        label="发货时间"/>
      <el-table-column
        prop="origin"
        label="出发地"/>
      <el-table-column
        prop="destination"
        label="目的地"/>
      <el-table-column
        fixed="right"
        label="管理"
        width="330">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().toDetailClick(scope.row.uuid)">
            详 情
          </el-button>
          <el-button
            size="mini"
            type="danger"
            class="mini-el-button"
            plain
            @click="event().onUpdateClick(scope.row.uuid)">
            更新物流
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>


    <!-- 更新物流 -->
    <el-dialog
      :title="updateTitle"
      width="720px"
      :visible.sync="updateDialog">
      <el-form
        :model="addBody"
        label-position="left"
        :rules="rules2"
        ref="ruleForm2"
        label-width="100px"
        class="demo-ruleForm">
        <el-form-item
          label="时 间"
          prop="time">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="addBody.time"
            type="datetime"
            placeholder="选择日期时间"/>
        </el-form-item>
        <el-form-item
          label="途径点"
          prop="point">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="addBody.point"
            :fetch-suggestions="searchDelivery"
            placeholder="请输入内容"
            @select="handleSelect">
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"/>
            <template slot-scope="{ item }">
              <div class="name">{{ item.title }}</div>
              <span class="addr">{{ item.address }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item
          label="当前状态"
          prop="address">
          <el-input
            class="dk-input"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            v-model="addBody.address"/>
        </el-form-item>
      </el-form>
      <div
        id="allmap"
        style="width:100%;height:400px"/>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="updateDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureClick('ruleForm2')">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
// eslint-disable-next-line
import BMap from 'BMap';
import { getLogisticsList, updateLogistics } from '../../api/logistics'
import timeChange from '../../mixins/time-change'
import { imgDomain } from '../../configs/env'

export default {
  mixins: [timeChange],
  data() {
    return {
      imgDomain,
      updateTitle: '新增',
      updateDialog: false,
      restaurants: [],
      addBody: {
        uuid: '',
        address: '',
        time: '',
        coordinate: {
          lat: 0,
          long: 0,
        },
        point: '',
      },
      body: {
        begin_time: '',
        end_time: '',
        keyword: '',
        page_index: 1,
        page_size: 20,
      },
      times: [],
      total: 0,
      tableData: [
      ],
      rules2: {
        address: [
          { required: true, message: '请输入当前状态', trigger: 'blur' },
        ],
        time: [
          { required: true, message: '请输入时间', trigger: 'blur' },
        ],
        point: [
          { required: true, message: '请输入途径点', trigger: 'blur' },
        ],
      },
    };
  },

  components: {
  },
  mounted() {
  },
  created() {
    this.network().getLogisticsList()
  },
  methods: {

    createMap() {
      // 百度地图API功能
      this.map = new BMap.Map('allmap'); // 创建Map实例
      this.map.centerAndZoom(new BMap.Point(114.064552, 22.548456), 13); // 初始化地图,设置中心点坐标和地图级别
      // map.setCurrentCity('北京'); // 设置地图显示的城市 此项是必须设置的
      this.map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
    },
    searchDelivery(queryString, cb) {
      const local = new BMap.LocalSearch(this.map);
      local.search(this.addBody.point);
      setTimeout(() => {
        this.querySearch(queryString, cb, local.getResults() || { Gq: [] })
      }, 1000);
    },
    querySearch(queryString, cb, { Gq: address }) {
      const { restaurants } = this;
      const results = queryString ? address : restaurants;
      cb(results);
    },
    handleSelect({ title, point: { lat, lng } }) {
      this.addBody.point = title
      this.addBody.coordinate.lat = lat
      this.addBody.coordinate.long = lng
      this.panTo(lat, lng)
    },
    panTo(lat, lng) {
      this.map.panTo(new BMap.Point(lng, lat));
      this.map.setZoom(20);
    },
    handleCurrentChange() {
      this.network().getLogisticsList()
    },
    event() {
      return {
        toAddClick: () => {
          this.$router.push({ path: '/logistics-management/add' })
        },
        toDetailClick: (uuid) => {
          this.$router.push({ path: '/logistics-management/detail', query: { uuid } })
        },
        onUpdateClick: (uuid) => {
          this.updateDialog = true
          this.addBody.uuid = uuid
          this.$nextTick(() => {
            this.createMap()
          })
        },
        onSureClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // 调接口
              this.network().updateLogistics()
            } else {
              console.log('error submit!!');
            }
          });
        },
      }
    },
    network() {
      return {
        getLogisticsList: async () => {
          const { status, data } = await getLogisticsList(this.body)
          if (status !== 200) return
          this.tableData = data.data
          this.total = data.total
        },
        updateLogistics: async () => {
          const { status } = await updateLogistics(this.addBody)
          if (status !== 200) return
          this.network().getLogisticsList()
          this.$notify({
            title: '更新成功',
            message: '更新物流单成功',
            type: 'success',
          });
          this.updateDialog = false
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}

.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vuepage/logistics/list.vue